import { render, staticRenderFns } from "./PressRoomArticle.vue?vue&type=template&id=34451fd7&"
import script from "./PressRoomArticle.vue?vue&type=script&lang=js&"
export * from "./PressRoomArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports